import React, { useState } from 'react'
import ShoutPopUp from './ShoutPop'
import Shout from './Shout'

export default function Index(props) {
  const shoutIsPopUp = props.options.popUp?.[props.locationIndex] ? true : false
  // const shoutIsPopUp = false

  if (shoutIsPopUp) {
    return <ShoutPopUp {...props} />
  } else {
    return <Shout {...props} />
  }
}
